import React, { Component } from 'react';
import * as styles from "./HightlightsSection.module.scss";
import { Link } from "react-router-dom";

import highlightsImg from '../../../../assets/homepage/highlights-section-img.png';
import highlightsImgSmall from '../../../../assets/homepage/highlights-section-img_small.png';
import ScrollSection from "../ScrollSection/ScrollSection";

class HighlightsSection extends Component {
  componentDidMount() {
    // Adding our Highlights Unit
    const script = document.createElement("script");
    script.id = "fa386f30c5ba45c084f30b0c630a190a";
    script.innerText = (`cnxps.cmd.push(function () { cnxps({ playerId: '052b179a-538f-4fd1-b6ef-d1dcf3ffa7ad'}).render('fa386f30c5ba45c084f30b0c630a190a'); });`);

    const highlightsContainer = document.getElementById('highlights');
    highlightsContainer.appendChild(script);
  }

  render() {
    return (
      <section className={styles['homepage-highlights']} id="homepage-highlights">
        <div className={styles['homepage-container']}>
          <div className={styles['homepage-highlights-container']}>
            <div className={styles['homepage-highlights__content']}>
            <div className={styles['homepage-highlights__scroll-section']}>
                <ScrollSection playspaceActive={true}/>
              </div>
              <h2 className={styles['homepage-section__title']}>
                Boost your video revenue with a turn-key video monetization platform.
              </h2>
              <p className={styles['homepage-section__subtitle']}>
                Quickly add new revenue streams while engaging readers.
                Leverage your existing content to craft brand safe video stories designed for monetization.
              </p>
              <Link to="/playspace" className={styles['homepage-highlights__link']}>UNLOCK YOUR REVENUE</Link>
            </div>
            <div className={styles['homepage-highlights__img-container']}>
              <img src={highlightsImg} alt="" className={styles['homepage-highlights__img-large']}/>
              <img src={highlightsImgSmall} alt="" className={styles['homepage-highlights__img-small']}/>
              <div className={styles['homepage-highlights__player']}>
                <div id="highlights"/>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default HighlightsSection;
